

import { State } from 'vuex-class'
import { Component, Vue } from 'vue-property-decorator'
import { Company } from '@/firestore'

@Component
export default class UserCompaniesMixin extends Vue {
  @State('companies')
  public userCompanies!: { [companyId: string]: Company }
}

